import { Grid, Typography } from '@mui/material';

type TransactionDetailsItemProps = {
  property: string;
  label: string;
  value: string;
};

const TransactionDetailsItem = ({
  property,
  label,
  value,
}: TransactionDetailsItemProps) => {
  return (
    <Grid size={{ xs: 6 }} mb={1}>
      <Typography
        mb={1}
        sx={{ fontWeight: 'bold' }}
        data-testid={`TransactionDetailsDrawer.${property}.Label`}
      >
        {label}
      </Typography>
      <Typography data-testid={`TransactionDetailsDrawer.${property}.Value`}>
        {value}
      </Typography>
    </Grid>
  );
};

export default TransactionDetailsItem;
